export const siteLanguagesEng = 'en';
export const ErrorChangeAccountMsgEng = 'Error with switching accounts. Inform your administrator.';;
